import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CustomIconsService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  init() {
    const icons = [
      'add',
      'arrow-back',
      'arrow-left',
      'arrow-right',
      'basic-protection',
      'calendar',
      'close',
      'close-filled',
      'close-filled-normal',
      'close-outline',
      'check',
      'check-filled',
      'check-outline',
      'direction-down',
      'discount-protection',
      'driver-protection',
      'edited',
      'filter',
      'gap-coverage',
      'info',
      'info-filled',
      'search',
      'sort',
      'contrast',
      'copy',
      'eye',
      'download',
      'foreign-travel',
      'free-workshop',
      'success-with-to-do',
      'elektro-vereinbarungen',
      'person',
      'phone',
      'remove',
    ];

    icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        `cp-${icon}`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/${icon}.svg`)
      );
    });
  }
}
